/* assets/product-details-drawer.js */
(() => {
  const DURATION = 650;                                // adjust speed (ms)
  const EASE     = 'cubic-bezier(0.16,0.84,0.44,1)';   // adjust easing
  const supportsWAAPI = 'animate' in Element.prototype;
  const prefersReduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  const lockScroll = (on) => {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  };

  async function openDrawer(drawer) {
    const overlay = drawer.querySelector('.pdp-drawer__overlay');
    const panel   = drawer.querySelector('.pdp-drawer__panel');

    // 1) Make it visible per your CSS
    drawer.classList.add('is-open');
    lockScroll(true);

    // 2) Set start states to override .is-open CSS (overlay would otherwise jump to 1)
    overlay.style.opacity = '0';
    panel.style.transform = 'translateX(100%)';

    if (!supportsWAAPI || prefersReduce) {
      // No animation support — snap to end
      overlay.style.opacity = '1';
      panel.style.transform = 'translateX(0)';
      return;
    }

    // 3) Animate
    overlay.animate([{opacity:0},{opacity:1}], {
      duration: Math.max(250, DURATION - 150),
      easing: 'linear',
      fill: 'forwards'
    });

    await panel.animate([{transform:'translateX(100%)'},{transform:'translateX(0)'}], {
      duration: DURATION,
      easing: EASE,
      fill: 'forwards'
    }).finished;
  }

  async function closeDrawer(drawer) {
    const overlay = drawer.querySelector('.pdp-drawer__overlay');
    const panel   = drawer.querySelector('.pdp-drawer__panel');

    if (!supportsWAAPI || prefersReduce) {
      drawer.classList.remove('is-open');
      overlay.style.opacity = '';
      panel.style.transform = '';
      lockScroll(false);
      return;
    }

    overlay.animate([{opacity:1},{opacity:0}], {
      duration: Math.max(200, DURATION - 200),
      easing: 'linear',
      fill: 'forwards'
    });

    await panel.animate([{transform:'translateX(0)'},{transform:'translateX(100%)'}], {
      duration: DURATION,
      easing: EASE,
      fill: 'forwards'
    }).finished;

    // Cleanup and actually hide
    drawer.classList.remove('is-open');
    overlay.style.opacity = '';
    panel.style.transform = '';
    lockScroll(false);
  }

  // Click handlers (use your existing data attributes)
  document.addEventListener('click', (e) => {
    const openBtn  = e.target.closest('[data-drawer-open]');
    const closeBtn = e.target.closest('[data-drawer-close]');
    const isOverlay = e.target.classList?.contains('pdp-drawer__overlay');

    if (openBtn) {
      const drawer = document.getElementById(openBtn.getAttribute('data-drawer-open'));
      if (drawer && !drawer.classList.contains('is-animating')) {
        openDrawer(drawer);
      }
    }
    if (closeBtn || isOverlay) {
      const drawer = e.target.closest('.pdp-drawer');
      if (drawer) closeDrawer(drawer);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const open = document.querySelector('.pdp-drawer.is-open');
      if (open) closeDrawer(open);
    }
  });
})();
